import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  email: string;
  handleSubmit: (email: string, onError: (message: string) => void) => void;
  handleCancel: () => void;
};

export const ForgotPasswordForm: React.FC<Props> = ({
  email,
  handleSubmit,
  handleCancel,
}) => {
  const [hasEmailError, setHasEmailError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const schema = useMemo(() => {
    return z.object({
      email: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    unknown,
    FieldValues
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ email: "" }}
      onSubmit={({ email }) => {
        handleSubmit(email, (message) => {
          setHasEmailError(true);
          setErrorMessage(message);
        });
      }}
    >
      <StyledTextContainer>
        入力したメールアドレスに、パスワード再設定メールを送信します。届いたメールに記載しているURLにアクセスしていただき、パスワードの再設定を行ってください。
      </StyledTextContainer>

      <Input
        label="メールアドレス"
        name="email"
        type="email"
        autoFocus
        defaultValue={email}
        hasError={hasEmailError}
        errorMessage={errorMessage}
        required
      />

      <StyledFooter>
        <Button variant="filled" text="送信" type="submit" fullWidth />
        <Button
          variant="link"
          text="キャンセル"
          type="button"
          onClick={handleCancel}
        />
      </StyledFooter>
    </FormTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 24px;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  gap: 20px;
`;
